import { render, staticRenderFns } from "./HomeBlank.vue?vue&type=template&id=619a2c85"
import script from "./HomeBlank.vue?vue&type=script&lang=js"
export * from "./HomeBlank.vue?vue&type=script&lang=js"
import style0 from "./HomeBlank.vue?vue&type=style&index=0&id=619a2c85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports